import * as Sentry from "@sentry/react";

let initialized = false;
const isEnabled =
  import.meta.env.VITE_APP_ENVIRONMENT == "prod" ||
  import.meta.env.VITE_APP_ENVIRONMENT == "staging";

const init = (): void => {
  if (isEnabled && !initialized) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      release: import.meta.env.VITE_SENTRY_RELEASE,
      environment: import.meta.env.VITE_APP_ENVIRONMENT,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      tracesSampleRate: 1.0,
      tracePropagationTargets: [],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
    initialized = true;
  }
};

const signIn = ({
  id,
  fuid,
  fullName,
  email,
}: {
  id?: number;
  fuid?: string | null;
  email?: string;
  fullName?: string;
}): void => {
  if (isEnabled) {
    Sentry.setUser({
      id: String(id),
      fullName: fullName,
      fuid: fuid,
      email: email,
    });
  }
};

const signOut = (): void => {
  if (isEnabled) {
    Sentry.setUser(null);
  }
};

export { init, signIn, signOut };
